import { CertificateItem } from '../components/CertificateItem';
import { certificateService } from '../services/certificateService';
import { Certificate } from '../types';
import { useEffect, useState } from 'react';

export function MyCertificatesPage() {
    const [certificates, setCertificates] = useState<Certificate[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchCertificates = async () => {
            try {
                const data = await certificateService.getAllCertificatesForEmployee();
                // Transform the API response to match our Certificate type
                const transformedCertificates: Certificate[] = data.map((cert: any) => ({
                    id: cert.id,
                    courseId: cert.course_id,
                    title: cert.title,
                    courseTitle: cert.courses?.title || cert.title,
                    issued_at: cert.issued_at,
                    expiryDate: cert.expiry_date,
                    image: cert.image
                }));
                setCertificates(transformedCertificates);
            } catch (err) {
                setError('Failed to fetch certificates');
                console.error('Error fetching certificates:', err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchCertificates();
    }, []);

    const handleDownloadCertificate = async (certificate: Certificate) => {
        try {
            const { blob, filename } = await certificateService.downloadCertificate(certificate.id);
            
            // Create download link
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error downloading certificate:', error);
            alert('Failed to download certificate. Please try again later.');
        }
    };

    return (
        <div>
            {isLoading ? (
                <div className="flex justify-center items-center h-64">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-sky-500"></div>
                </div>
            ) : error ? (
                <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                    <p className="text-red-600">{error}</p>
                </div>
            ) : certificates.length > 0 ? (
                <div className="bg-white rounded-lg shadow border border-slate-200">
                    <ul className="divide-y divide-slate-200">
                        {certificates.map(cert => (
                            <CertificateItem
                                key={cert.id}
                                certificate={cert}
                                onViewCertificate={handleDownloadCertificate}
                            />
                        ))}
                    </ul>
                </div>
            ) : (
                <p className="text-center text-slate-500 mt-10">You haven't earned any certificates yet.</p>
            )}
        </div>
    );
}